import { render, staticRenderFns } from "./forwardingDetails.vue?vue&type=template&id=78f7e7c3"
import script from "./forwardingDetails.vue?vue&type=script&lang=js"
export * from "./forwardingDetails.vue?vue&type=script&lang=js"
import style0 from "./forwardingDetails.vue?vue&type=style&index=0&id=78f7e7c3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports